import { BaseResource } from '../base-resource';
import { BookingStatus } from './booking-status';
import { BookingPackages } from './booking-packages';
import { Notes } from './booking-notes';
import { BookingContact } from './booking-contact';
import { PriceConcession } from './price-group';
import { PaymentTerm } from './Payment-term';
import { AdHocDocument } from 'src/modules/models/booking/adhoc-document'
import { Question } from 'src/modules/models/item/question';

import { jsonIgnore } from "json-ignore";
import { environment } from "src/environments/environment";
import { Address, Client, CommunicationMethod } from "../client/client";
import { BookingItem } from "../regular-portal/booking/save-booking/booking-item";
import { CancellationReason } from "src/modules/public-web/components/layout/models/bookingCart.model";
import {tr} from 'date-fns/locale';


export class Booking extends BaseResource {
    constructor() {
        super();
        this.type = "booking";
        if(environment.SalesChannel && environment.SalesChannel != 0) {
          this.salesChannelId = environment.SalesChannel;
        }
    }
    BookingType: string;
    bookingReference: string;
    attendees: number;
    bookingDate: string;
    specialNote: string;
    confirmedDate: string;
    cancelled: boolean;
    confirmed: boolean;
    margin: number;
    note: string;
    poReference: string;
    salesChannelId: number;
    bookingPackages: BookingPackages[]; ///sss
    @jsonIgnore() entityConfigurationProfileId: number;
    contact: BookingContact;
    priceConcession: PriceConcession;
    deliveryAddress: Address;
    deliveryCommunicationMethods: CommunicationMethod[];
    paymentTerm: PaymentTerm;
    eventName: string;
    temporary: boolean;
    eventStartDate: string;
    eventEndDate: string;
    statusText: string;
    questionSummaries: any[];
    documents: AdHocDocument[];
    bookingStatus: any;
    dueAmount: number;
    invoicedAmount: number;
    grossAmount: number;
    bookingTypeId: number;
    taxAmount: number;
    netAmount: number;
    bookingInvoices: BookingInvoice[];
    paidAmount: number;
    grossAmountExcludingBond: number;
    collectionAddress: Address;
    isTemporary: boolean;
    cancelledDate?: string;
    cancellationFee: number;
    salesPerson: any;
    deliveryMethod: DeliveryMethod;
    cancellationReasonId: string;
    cancellationNote: string;
    notes: Notes[];
    venueEmailId?: string;
    discountAmountExcludingTax: number;
    discountAmountIncludingTax: number;
    isExpired: boolean;
    invoiceEmailAddress: string;
    client: Client;
    facilityName: string;
    bookingUserDefinedFields : BookingUserDefinedField[];
}
export class UserDefinedField extends BaseResource {
  constructor() {
    super();
    this.type = "UserDefinedField";
  }
  id: string;
}
export class UserDefinedFieldValue extends BaseResource {
  constructor() {
    super();
    this.type = "UserDefinedFieldValue";
  }
  id: string;
}
export class BookingUserDefinedField extends BaseResource {
  constructor() {
    super();
    this.type = "BookingUserDefinedField";
  }
  id: string;
  value: string;
  // Relationships
  userDefinedFieldValue: UserDefinedFieldValue[];
  userDefinedField: UserDefinedField;
}


export class DeliveryMethod extends BaseResource {
  constructor() {
    super();
    this.type = "DeliveryMethod";
  }
  name: string;
  price: number | null;
  cost: number | null;
  description: string;
  cutoffDate: number | null;
  cutOffTime: string | null;
  international: boolean | null;
  collection: boolean | null;
  electronic: boolean | null;
  printAtHome: boolean | null;
  shippingProviderId: number | null;
  shippingPrivider: string;
  serviceProviderId: number | null;
  serviceProvider: string;
  @jsonIgnore() defaultDeliveryMethod: boolean;
  @jsonIgnore() postal: boolean;
  @jsonIgnore() email: boolean;

  @jsonIgnore()
  initialize(d) {
    if (d) {
      this.id = d.id;
      this.name = d.name;
      this.price = d.price;
      this.cost = d.cost;
      this.description = d.description;
      this.cutoffDate = d.cutoffDate;
      this.cutOffTime = d.cutOffTime;
      this.international = d.international;
      this.collection = d.collection;
      this.electronic = d.electronic;
      this.printAtHome = d.printAtHome;
      this.shippingProviderId = d.shippingProviderId;
      this.shippingPrivider = d.shippingPrivider;
      this.defaultDeliveryMethod = d.defaultDeliveryMethod;
      this.serviceProviderId = d.serviceProviderId;
      this.serviceProvider = d.serviceProvider;
      this.postal = false;
      if (!this.collection && !this.electronic && !this.printAtHome) {
        this.postal = true;
        this.email = false;
        this.collection = false;
      } else if (this.collection && !this.electronic && this.printAtHome) {
        this.collection = true;
        this.postal = false;
        this.email = false;
      } else if ((!this.collection && this.electronic) || this.printAtHome) {
        this.email = true;
        this.postal = false;
        this.collection = false;
      }
    }
    return this;
  }
}
export class BookingInvoice extends BaseResource {
  invoiceReference: string;
  invoiceDate: string;
  totalAmount: number;
  taxAmount: number;
  invoiceOutstandingAmount: number;
  paymentDueDate: string;
  paidAmount: number;
  includeBond: boolean;
}

export class BookingAdapter {
  static populateQuestions(booking, bookingQuestionnaires) {
    let totalCount = 0;
    if (
      booking &&
      booking.facilitySummaries &&
      booking.facilitySummaries.length > 0
    ) {
      booking.facilitySummaries.forEach((fcs) => {
        if (
          fcs &&
          fcs.bookingItemSummaries &&
          fcs.bookingItemSummaries.length > 0
        ) {
          fcs.bookingItemSummaries.forEach((bis) => {
            var filterdbookingItemQuestionnaires = bookingQuestionnaires.filter(
              function (bookingQuestionnaire) {
                return (
                  bookingQuestionnaire &&
                  bookingQuestionnaire != null &&
                  bookingQuestionnaire.bookingItem &&
                  bookingQuestionnaire.bookingItem != null &&
                  bookingQuestionnaire.bookingItem.id == bis.bookingItemId
                );
              }
            );

            if (
              filterdbookingItemQuestionnaires &&
              filterdbookingItemQuestionnaires.length > 0
            ) {
              bis.question = [];
              bis.question = bis.question as Question[];
              filterdbookingItemQuestionnaires.forEach((fbiq) => {
                if (fbiq.bookingQuestions) {
                  fbiq.bookingQuestions.forEach((biq) => {
                    let question = biq;
                    // question.id = biq.id;
                    // question.primaryQuestionId = biq.primaryQuestionId;
                    // question.conditionOperator = biq.conditionOperator;
                    // question.condition = biq.condition;
                    question.questionText = biq.questionText?? biq.question.questionText
                    question.mandatory  = biq.mandatory?? biq.question.mandatory
                    question.isBookingQuestion = true;


                    if (
                      biq.type == "textQuestionAnswer" &&
                      biq.answer &&
                      biq.answer.trim() != ""
                    ) {
                      question.answeredText = biq.answer;
                      question.originalAnswer = question.answeredText;
                      question.isSaved = true;
                    } else if (
                      biq.type == "booleanQuestionAnswer" &&
                      biq.answer !== undefined
                    ) {
                      question.answeredText = biq.answer ? "Yes" : "No";
                      question.originalAnswer = question.answeredText;
                      question.isSaved = true;
                    } else if (biq.type == "singleChoiceQuestionAnswer") {
                      if (biq.bookingAnswerChoice) {
                        question.answeredText =
                          biq.bookingAnswerChoice.bookingQuestionChoice.id;
                        question.originalAnswer = question.answeredText;
                        question.isSaved = true;
                        question.bookingAnswerChoice = biq.bookingAnswerChoice;
                      }

                      question.bookingQuestionChoices =
                        biq.bookingQuestionChoices;
                    }
                    else if (biq.type == "multipleChoiceQuestionAnswer") {
                      question.selectedAnswers = [];
                      question.bookingQuestionChoices =
                        biq.bookingQuestionChoices;
                      if (
                        biq.bookingQuestionChoices &&
                        biq.bookingAnswerChoice
                      ) {
                        if (biq.bookingAnswerChoice.length > 0) {
                          biq.bookingQuestionChoices.forEach((qac) => {
                            let isSelected = biq.bookingAnswerChoice.find(
                              (bac) => bac.bookingQuestionChoice.id == qac.id
                            );
                            if (isSelected) {
                              if (!question.question.quantityRequired) {
                                qac.isSelectedAnswer = isSelected.quantity == 1;
                              }
                              qac.Quantity = isSelected.quantity;
                              if(question.question.quantityRequired) {
                                if(qac.Quantity > 0)
                                  qac.isSelectedAnswer = true;
                              }
                              question.selectedAnswers.push(qac.id);
                            }
                            if (question.selectedAnswers.length > 0)
                              question.isSaved = true;
                          });
                        }
                      }
                    }
                    else if(biq.type == "fileUploadQuestionAnswer"){
                      if(biq.answerUploadedFiles != null){
                        question.answerUploadedFiles = biq.answerUploadedFiles;
                        question.isSaved = true;
                        let idString = "";
                        for (let i = 0; i < biq.answerUploadedFiles.length; i++) {
                          if (i > 0) {
                            idString += ",";
                          }
                          idString += biq.answerUploadedFiles[i].id;
                        }
                        question.answeredText = idString;
                      }
                    }
                    question.type = biq.question.type;
                    bis.question.push(question);
                    totalCount++;
                  });
                }
              });
              bis.totalAnsweredQuestions = totalAnsweredQuestionsCount(
                bis.question
              );
            }

            // booking upsell item question pop
            if (bis.upsellSummaries && bis.upsellSummaries.length > 0) {
              bis.upsellSummaries.forEach((us) => {
                var filterdbookingUpsellQuestionnaires =
                  bookingQuestionnaires.filter(function (bookingQuestionnaire) {
                    return (
                      bookingQuestionnaire &&
                      bookingQuestionnaire != null &&
                      bookingQuestionnaire.bookingItem &&
                      bookingQuestionnaire.bookingItem != null &&
                      bookingQuestionnaire.bookingItem.id == us.bookingItemId
                    );
                  });

                if (
                  filterdbookingUpsellQuestionnaires &&
                  filterdbookingUpsellQuestionnaires.length > 0
                ) {
                  us.question = [];
                  filterdbookingUpsellQuestionnaires.forEach((fbuq) => {
                    if (fbuq.bookingQuestions) {
                      fbuq.bookingQuestions.forEach((biq) => {
                        let question = biq;
                        // question.id = biq.id;
                        // question.primaryQuestionId = biq.primaryQuestionId;
                        // question.conditionOperator = biq.conditionOperator;
                        // question.condition = biq.condition
                        question.questionText = biq.questionText?? biq.question.questionText
                        question.mandatory  = biq.mandatory?? biq.question.mandatory
                        question.isBookingQuestion = true;
                        /*question.type = biq.question.type;*/

                        if (
                          biq.type == "textQuestionAnswer" &&
                          biq.answer &&
                          biq.answer.trim() != ""
                        ) {
                          question.answeredText = biq.answer;
                          question.originalAnswer = question.answeredText;
                          question.isSaved = true;
                        } else if (
                          biq.type == "booleanQuestionAnswer" &&
                          biq.answer !== undefined
                        ) {
                          question.answeredText = biq.answer ? "Yes" : "No";
                          question.originalAnswer = question.answeredText;
                          question.isSaved = true;
                        } else if (biq.type == "singleChoiceQuestionAnswer") {
                          if (biq.bookingAnswerChoice) {
                            question.answeredText =
                              biq.bookingAnswerChoice.bookingQuestionChoice.id;
                            question.originalAnswer = question.answeredText;
                            question.isSaved = true;
                            question.bookingAnswerChoice =
                              biq.bookingAnswerChoice;
                          }
                          question.bookingQuestionChoices =
                            biq.bookingQuestionChoices;
                        }
                        else if (biq.type == "multipleChoiceQuestionAnswer") {
                          question.selectedAnswers = [];
                          question.bookingQuestionChoices =
                            biq.bookingQuestionChoices;
                          if (
                            biq.bookingQuestionChoices &&
                            biq.bookingAnswerChoice
                          ) {
                            if (biq.bookingAnswerChoice.length > 0) {
                              biq.bookingQuestionChoices.forEach((qac) => {
                                let isSelected = biq.bookingAnswerChoice.find(
                                  (bac) =>
                                    bac.bookingQuestionChoice.id == qac.id
                                );
                                if (isSelected) {
                                  if (!question.question.quantityRequired) {
                                    qac.isSelectedAnswer = true;
                                  }
                                  qac.Quantity = isSelected.quantity;
                                  if(question.question.quantityRequired) {
                                    if(qac.Quantity > 0)
                                      qac.isSelectedAnswer = true;
                                  }
                                  question.selectedAnswers.push(qac.id);
                                }
                                question.isSaved =
                                  question.selectedAnswers.length > 0;
                              });
                            }
                          }
                        }
                        else if(biq.type == "fileUploadQuestionAnswer"){
                          if(biq.answerUploadedFiles != null){
                            question.answerUploadedFiles = biq.answerUploadedFiles;
                            question.isSaved = true;
                            let idString = "";
                            for (let i = 0; i < biq.answerUploadedFiles.length; i++) {
                              if (i > 0) {
                                idString += ",";
                              }
                              idString += biq.answerUploadedFiles[i].id;
                            }
                            question.answeredText = idString;
                          }
                        }
                        question.type = biq.question.type;
                        us.question.push(question);
                        totalCount++;
                      });
                    }
                  });
                  //calculating un-answered count
                  bis.totalAnsweredQuestions += totalAnsweredQuestionsCount(
                    us.question
                  );
                }
              });
            }
          });
        }
      });
    }
    var filterdbookingPackageQuestionnaires = [];
    filterdbookingPackageQuestionnaires = bookingQuestionnaires.filter(
      (bookingQuestionnaire) =>
        bookingQuestionnaire &&
        bookingQuestionnaire.type === "packageBookingQuestionnaire" &&
        bookingQuestionnaire.bookingPackage &&
        booking.bookingPackages.some(
          (bp) => bookingQuestionnaire.bookingPackage.id === bp.id
        )
    );
    if (
      filterdbookingPackageQuestionnaires &&
      filterdbookingPackageQuestionnaires.length > 0
    ) {
      booking.packageQuestion = [];
      filterdbookingPackageQuestionnaires.forEach((pbiq) => {

        const pkgId = pbiq.bookingPackage.id;
        let packageEntry = booking.packageQuestion.find(p => p.packageId === pkgId);
        if (!packageEntry) {
          packageEntry =
            {
              packageId: pkgId,
              packageQuestions: [],
              totalAnsweredPackageQuestions: 0,
              totalPackageQuestions : 0
            };
          booking.packageQuestion.push(packageEntry);
        }

        if (pbiq.bookingQuestions) {
          pbiq.bookingQuestions.forEach((bpq) => {
            let question = bpq; // use bpq
            // question.id = bpq.id;
            // question.primaryQuestionId = bpq.primaryQuestionId;
            // question.conditionOperator = bpq.conditionOperator;
            // question.condition = bpq.condition;
            question.questionText = bpq.questionText?? bpq.question.questionText
            question.mandatory  = bpq.mandatory?? bpq.question.mandatory
            question.isBookingQuestion = true;


            if (
              bpq.type == "textQuestionAnswer" &&
              bpq.answer &&
              bpq.answer.trim() != ""
            ) {
              question.answeredText = bpq.answer;
              question.originalAnswer = question.answeredText;
              question.isSaved = true;
            } else if (
              bpq.type == "booleanQuestionAnswer" &&
              bpq.answer !== undefined
            ) {
              question.answeredText = bpq.answer ? "Yes" : "No";
              question.originalAnswer = question.answeredText;
              question.isSaved = true;
            } else if (bpq.type == "singleChoiceQuestionAnswer") {
              if (bpq.bookingAnswerChoice) {
                question.answeredText =
                  bpq.bookingAnswerChoice.bookingQuestionChoice.id;
                question.originalAnswer = question.answeredText;
                question.isSaved = true;
                question.bookingAnswerChoice = bpq.bookingAnswerChoice;
              }
              question.bookingQuestionChoices = bpq.bookingQuestionChoices;
            } else if (bpq.type == "multipleChoiceQuestionAnswer") {
              question.selectedAnswers = [];
              question.bookingQuestionChoices = bpq.bookingQuestionChoices;
              if (bpq.bookingQuestionChoices && bpq.bookingAnswerChoice) {
                if (bpq.bookingAnswerChoice.length > 0) {
                  bpq.bookingQuestionChoices.forEach((qac) => {
                    let isSelected = bpq.bookingAnswerChoice.find(
                      (bac) => bac.bookingQuestionChoice.id == qac.id
                    );
                    if (isSelected) {
                      if (!question.question.quantityRequired) {
                        qac.isSelectedAnswer = true;// isSelected.quantity == 1;
                      }
                      qac.Quantity = isSelected.quantity;
                      if(question.question.quantityRequired) {
                        if(qac.Quantity > 0)
                          qac.isSelectedAnswer = true;
                      }
                      question.selectedAnswers.push(qac.id);
                    }
                    if (question.selectedAnswers.length > 0)
                      question.isSaved = true;
                  });
                }
              }
              question.answerChoices = question.bookingQuestionChoices;
            }
            else if(bpq.type == "fileUploadQuestionAnswer"){
              if(bpq.answerUploadedFiles != null){
                question.answerUploadedFiles = bpq.answerUploadedFiles;
                question.isSaved = true;
                let idString = "";
                for (let i = 0; i < bpq.answerUploadedFiles.length; i++) {
                  if (i > 0) {
                    idString += ",";
                  }
                  idString += bpq.answerUploadedFiles[i].id;
                }
                question.answeredText = idString;
              }
            }
            question.type = bpq.question.type;
            packageEntry.packageQuestions.push(question);
            totalCount++;
          });
        }
        packageEntry.totalAnsweredPackageQuestions = totalAnsweredQuestionsCount(packageEntry.packageQuestions);
        packageEntry.totalPackageQuestions = packageEntry.packageQuestions.length;
      });
    }

    return { booking: booking, totalQuestionCount: totalCount };
  }
}

function totalAnsweredQuestionsCount(question): number {
  var count = 0;
  if (question) {
    for (var q of question) {
      if (
        (q.type == "textQuestion" ||
          q.type == "booleanQuestion" ||
          q.type == "singleChoiceQuestion") &&
        q.answeredText != undefined &&
        q.answeredText != null &&
        q.answeredText != "" &&
        q.mandatory !== undefined
      ) {
        count++;
      } else if (q.type == "multipleChoiceQuestion") {
        var answeredCount = 0;
        if (q.bookingQuestionChoices) {
          q.bookingQuestionChoices.forEach((ans, indx) => {
            if (q.quantityRequired && ans.Quantity) answeredCount++;
            else if (ans.isSelectedAnswer) answeredCount++;
          });
          if (answeredCount > 0) count++;
        }
      }else if(q.type == "fileUploadQuestion" &&
        q.answerUploadedFile != null &&
        q.mandatory !== undefined){
        count++;
      }
    }
  }
  return count;
}
